/** @format */

import React, {useContext} from 'react';
import {ProofingContext} from 'frontier/account/components/proofing/proofing_context';
import {DESIGN_ALERT_SEVERITIES_ICON} from 'frontier-constants';

export default function OrderDesignAlerts({proofId}) {
    const {
        data: {currentProof}
    } = useContext(ProofingContext);
    return currentProof.designs_alerts
        .reduce((alerts, alert) => {
            const index = alerts.findIndex(({design_alert_id}) => {
                return design_alert_id === alert.design_alert_id;
            });
            if (index === -1) {
                const comments = alert.comment?.length > 0 ? [alert.comment] : [];
                alerts.push({alert, comments});
            } else {
                if (alert.comment.length > 0) {
                    alerts[index].comments.push(alert.comment);
                    // filter for unique comments
                    alerts[index].comments = alerts[index].comments.filter((comment, i, arr) => {
                        return arr.indexOf(comment) === i;
                    });
                }
            }

            return alerts;
        }, [])
        .map((alert, index) => {
            const severityIcon =
                DESIGN_ALERT_SEVERITIES_ICON.find(
                    icon => icon.id === alert.alert.design_alert.severity_level_id
                )?.icon || '';
            return (
                <div key={index} className="mb-2">
                    <div style={{fontSize: '18px', fontWeight: 'bold'}}>
                        {alert.alert.design_alert.label}
                    </div>
                    <div>{alert.alert.design_alert.description}</div>
                    {alert.comments.length > 0 && (
                        <div className="alert alert-warning mt-1">
                            <div>Comments</div>
                            {alert.comments.map((comment, commentIndex) => {
                                return <div key={commentIndex}>{comment}</div>;
                            })}
                        </div>
                    )}
                </div>
            );
        });
}
